module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/3731c44886e9064dbcf2898b9876947d.svg";